export class ListDataCatalogPipelinesResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "pipelines",
            "baseName": "pipelines",
            "type": "Array<DataCatalogPipeline>",
            "format": ""
        },
        {
            "name": "nextPageToken",
            "baseName": "nextPageToken",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListDataCatalogPipelinesResponse.attributeTypeMap;
    }
    constructor() {
    }
}
